<template>
  <div v-if="userId != null" class="chat__header">
    <vs-navbar class="p-4 flex navbar-custom" color="white" type="flat">
      <div class="relative flex mr-4">
        <feather-icon
          icon="MenuIcon"
          class="mr-4 cursor-pointer"
          v-if="isSidebarCollapsed"
          @click.stop="$emit('openContactsSidebar')"
        />
        <avatar
          class="m-0 border-2 border-solid border-white"
          size="40px"
          :id="userDetails.avatar"
          @click.stop="$emit('showProfileSidebar', userId)"
        />
        <div
          class="h-3 w-3 border-white border border-solid rounded-full absolute right-0 bottom-0"
          :class="'bg-' + getStatusColor(false)"
        ></div>
      </div>
      <h6>{{ userDetails.fullName }}</h6>
      <vs-spacer />
      <feather-icon
        v-if="isInWhitelist"
        icon="VideoIcon"
        class="cursor-pointer mr-5"
        :svgClasses="[{ 'text-primary stroke-current': true }, 'w-6', 'h-6']"
        @click="$emit('videoCallUser', userDetails)"
      ></feather-icon>
      <feather-icon
        v-if="isInWhitelist"
        icon="PhoneIcon"
        class="cursor-pointer"
        :svgClasses="[{ 'text-primary stroke-current': true }, 'w-6', 'h-6']"
        @click="$emit('voiceCallUser', userDetails)"
      ></feather-icon>
    </vs-navbar>
  </div>
</template>

<script>
import Avatar from '@/views/components/common/Avatar'

export default {
  components: {
    Avatar
  },
  props: {
    userId: {
      type: String,
      required: true
    },
    isSidebarCollapsed: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    userDetails() {
      return this.$store.getters['chat/contact'](this.userId)
    },
    getStatusColor() {
      return isActiveUser => {
        const userStatus = this.getUserStatus(isActiveUser)

        if (userStatus === 'online') {
          return 'success'
        } else if (userStatus === 'do not disturb') {
          return 'danger'
        } else if (userStatus === 'away') {
          return 'warning'
        } else {
          return 'grey'
        }
      }
    },
    isInWhitelist() {
      return !!this.$store.getters['chat/whitelistContacts'].find(u => u.userId === this.userDetails.userId)
    }
  },
  methods: {
    getUserStatus(isActiveUser) {
      return isActiveUser ? this.$store.state.AppActiveUser.status : this.userDetails.status
    }
  }
}
</script>
